import { createAlchemyWeb3 } from "@alch/alchemy-web3";
// import { AlchemyProvider } from "ethers";
import { parseUnits, formatUnits, isAddress } from "ethers";
import contractABI from "../assets/abis/AuctionImplV4.json";
import tetherTokenABI from "../assets/abis/NinjaTetherToken.json";
import bidCoinABI from "../assets/abis/BidCoin.json";
import instance from "./AxiosConfig";
import { toast } from "react-toastify";
import { getAppKitProvider, getAppKitAccount } from "./AlchemyProvider";

const tetherTokenAddress = process.env.REACT_APP_CUSDT_ADDRESS;
const bidCoinAddress = process.env.REACT_APP_BIDCOIN_ADDRESS;

const alchemyKey = process.env.REACT_APP_DEV_RPC_WS_URL;
const web3 = createAlchemyWeb3(alchemyKey);

export const tetherTokenContract = new web3.eth.Contract(
    tetherTokenABI.abi,
    tetherTokenABI.address
);

export const bidCoinContract = new web3.eth.Contract(bidCoinABI.abi, bidCoinAddress);
export const initializeAuctionContract = (contractAddress) => {
    return new web3.eth.Contract(contractABI.abi, contractAddress);
};

const getWalletAddress = async () => {
    const account = await getAppKitAccount();
    return account?.address || "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266";
};

export const loadAuctionData = async (address) => {
    const auctionContract = initializeAuctionContract(address);
    try {
        const auctionState = await auctionContract.methods.getAuctionState().call();

        const safeFormatUnits = (value, decimals) => {
            try {
                return Number(formatUnits(value || "0", decimals)).toString();
            } catch (error) {
                console.error("Error formatting units:", error);
                return "0";
            }
        };

        let userBidAmounts = 0;
        const userAddress1 = localStorage.getItem("userAddress") || "0x0";

        if (auctionState._paused && userAddress1 !== "0x0") {
            userBidAmounts = await auctionContract.methods.userBidFees(userAddress1).call();
        }
        const auctionData = {
            userBidFees: userBidAmounts,
            address: address,
            currentBidPrice: auctionState._currentBidPrice.toString(),
            numberOfBids: auctionState._numberOfBids.toString(),
            winningBidder: auctionState._winningBidder.toLowerCase(),
            totalProfit: auctionState._totalProfit.toString(),
            auctionEnded: auctionState._auctionEnded,
            fomoPhaseActive: auctionState._fomoPhaseActive,
            auctionEndTime: auctionState._auctionEndTime,
            lastPriceUpdateTimestamp: auctionState._lastPriceUpdateTimestamp,
            ownerConfirmedDelivery: auctionState._ownerConfirmedDelivery,
            winnerConfirmedDelivery: auctionState._winnerConfirmedDelivery,
            assetDelivered: auctionState._assetDelivered,
            assetType: auctionState._assetType.toString(),
            rewardAssetAddress: auctionState._rewardAssetAddress.toLowerCase(),
            rewardAssetQty: safeFormatUnits(auctionState._rewardAssetQty, 0),
            rewardAssetPrice: safeFormatUnits(auctionState._rewardAssetPrice, 6),
            rewardAssetPurchased: auctionState._rewardAssetPurchased,
            discountFee: safeFormatUnits(auctionState._discountFee, 6),
            canEndAuction: auctionState._canEndAuction,
            refundClaimable: auctionState._refundClaimable,
            pool: auctionState._poolAddress,
            usdtPerBidCoin: auctionState._usdtPerBidCoin,
            paused: auctionState._paused,
        };
        // console.log("auctionData", auctionData);
        // Calculate progress and reserve price
        const reservePrice =
            Number(auctionState._rewardAssetQty) *
            Number(formatUnits(auctionState._rewardAssetPrice, 6));
        const progress = (Number(auctionState._currentBidPrice) / reservePrice) * 100;
        auctionData.progress = progress;
        auctionData.reservePrice = reservePrice;

        // Get user balances if address is valid
        const userAddress = localStorage.getItem("userAddress");
        if (isAddress(userAddress)) {
            const usdtBalance = await tetherTokenContract.methods.balanceOf(userAddress).call();
            const bidBalance = await bidCoinContract.methods.balanceOf(userAddress).call();
            auctionData.usdtBalance = safeFormatUnits(usdtBalance, 6);
            auctionData.bidBalance = safeFormatUnits(bidBalance, 18);
        }

        return auctionData;
    } catch (error) {
        console.error("Error loading auction data:", error);
        return {
            status: "😥 " + error.message,
        };
    }
};

/**
 *
 */
export const connectWallet = async () => {
    if (window.ethereum) {
        try {
            const addressArray = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const obj = {
                address: addressArray[0],
                status: "",
            };

            return obj;
        } catch (err) {
            return {
                address: "",
                status: "😥 " + err.message,
            };
        }
    } else {
        return {
            address: "",
            status: (
                <span>
                    <p>
                        {" "}
                        {/* 🦊{" "} */}
                        <a target="_blank" href={"https://metamask.io/download"}>
                            {/* You must install Metamask, a virtual Ethereum wallet, in your browser. */}
                        </a>
                    </p>
                </span>
            ),
        };
    }
};

/**
 *
 */
export const getCurrentWalletConnected = async () => {
    if (window.ethereum) {
        try {
            const addressArray = await window.ethereum.request({
                method: "eth_accounts",
            });
            if (addressArray.length > 0) {
                return {
                    address: addressArray[0],
                    status: "",
                };
            } else {
                return {
                    address: "",
                    status: "🦊 Connect to Metamask using the top right button.",
                };
            }
        } catch (err) {
            return {
                address: "",
                status: "😥 " + err.message,
            };
        }
    } else {
        return {
            address: "",
            status: (
                <span>
                    <p>
                        {" "}
                        {/* 🦊{" "} */}
                        <a target="_blank" href={"https://metamask.io/download"}>
                            {/* You must install Metamask, a virtual Ethereum wallet, in your browser. */}
                        </a>
                    </p>
                </span>
            ),
        };
    }
};

/**
 *
 */
export const placeBidHandler = async (contractAddress) => {
    const provider = window.ethereum;
    const userAddress = localStorage.getItem("userAddress");

    // Enhanced validation for userAddress
    if (!provider) {
        console.log("No provider found");
        return {
            status: "💡 Please install a Web3 wallet like MetaMask to continue.",
        };
    }

    if (!userAddress || userAddress === "undefined") {
        console.log("No user address found");
        return {
            status: "💡 Please connect your wallet to continue.",
        };
    }

    // Validate contract address
    if (!contractAddress || !isAddress(contractAddress)) {
        console.log("Invalid auction contract address");
        return {
            status: "Invalid auction contract address.",
        };
    }

    try {
        const auctionContract = initializeAuctionContract(contractAddress);
        const auctionState = await auctionContract.methods.getAuctionState().call();

        // Get the current discount fee from auction state
        const usdtAmountInWei = parseUnits(formatUnits(auctionState._discountFee, 6), 6);

        // Check allowance
        const currentAllowance = await tetherTokenContract.methods
            .allowance(userAddress, contractAddress)
            .call();

        if (BigInt(currentAllowance) < BigInt(usdtAmountInWei)) {
            const approveTransactionParameters = {
                data: tetherTokenContract.methods
                    .approve(contractAddress, usdtAmountInWei)
                    .encodeABI(),
                from: userAddress,
                to: tetherTokenAddress,
            };

            const approveTxHash = await provider.request({
                method: "eth_sendTransaction",
                params: [approveTransactionParameters],
            });

            // Wait for approval transaction to be mined
            await new Promise((resolve) => {
                const checkTx = async () => {
                    const receipt = await web3.eth.getTransactionReceipt(approveTxHash);
                    if (receipt) {
                        resolve();
                    } else {
                        setTimeout(checkTx, 1000);
                    }
                };
                checkTx();
            });
        } else {
            // console.log("Sufficient allowance already exists. Skipping approval.");
        }

        // Place the bid
        const bidTransactionParameters = {
            data: auctionContract.methods.placeBid().encodeABI(),
            from: userAddress,
            to: contractAddress,
        };

        const bidTxHash = await provider.request({
            method: "eth_sendTransaction",
            params: [bidTransactionParameters],
        });

        await new Promise((resolve) => {
            const checkTx = async () => {
                const receipt = await web3.eth.getTransactionReceipt(bidTxHash);
                if (receipt) {
                    resolve();
                } else {
                    setTimeout(checkTx, 1000);
                }
            };
            checkTx();
        });

        // Get updated auction state
        const updatedAuctionState = await auctionContract.methods.getAuctionState().call();

        let userBidAmounts = 0;
        const userAddress1 = localStorage.getItem("userAddress") || "0x0";
        if (updatedAuctionState._paused && userAddress1 !== "0x0") {
            userBidAmounts = await auctionContract.methods.userBidFees(userAddress1).call();
        }

        const auctionData = {
            userBidFees: userBidAmounts,
            address: contractAddress,
            assetDelivered: updatedAuctionState._assetDelivered,
            assetType: updatedAuctionState._assetType.toString(),
            auctionEndTime: updatedAuctionState._auctionEndTime,
            auctionEnded: updatedAuctionState._auctionEnded,
            currentBidPrice: updatedAuctionState._currentBidPrice.toString(),
            discountFee: safeFormatUnits(updatedAuctionState._discountFee, 6),
            fomoPhaseActive: updatedAuctionState._fomoPhaseActive,
            paused: updatedAuctionState._paused,
            ownerConfirmedDelivery: updatedAuctionState._ownerConfirmedDelivery,
            rewardAssetAddress: updatedAuctionState._rewardAssetAddress.toLowerCase(),
            rewardAssetPrice: safeFormatUnits(updatedAuctionState._rewardAssetPrice, 6),
            rewardAssetQty: safeFormatUnits(updatedAuctionState._rewardAssetQty, 0),
            totalProfit: updatedAuctionState._totalProfit.toString(),
            winnerConfirmedDelivery: updatedAuctionState._winnerConfirmedDelivery,
            winningBidder: updatedAuctionState._winningBidder.toLowerCase(),
            rewardAssetPurchased: updatedAuctionState._rewardAssetPurchased,
            pool: updatedAuctionState._poolAddress,
            numberOfBids: updatedAuctionState._numberOfBids.toString(),
            lastPriceUpdateTimestamp: updatedAuctionState._lastPriceUpdateTimestamp,
            canEndAuction: updatedAuctionState._canEndAuction,
            refundClaimable: updatedAuctionState._refundClaimable,
            usdtPerBidCoin: updatedAuctionState._usdtPerBidCoin,
        };

        // Calculate progress and reserve price
        const reservePrice =
            Number(updatedAuctionState._rewardAssetQty) *
            Number(formatUnits(updatedAuctionState._rewardAssetPrice, 6));
        const progress = (Number(updatedAuctionState._currentBidPrice) / reservePrice) * 100;
        auctionData.progress = progress;
        auctionData.reservePrice = reservePrice;

        // Get updated balances
        const usdtBalance = await tetherTokenContract.methods.balanceOf(userAddress).call();
        const bidBalance = await bidCoinContract.methods.balanceOf(userAddress).call();
        auctionData.usdtBalance = safeFormatUnits(usdtBalance, 6);
        auctionData.bidBalance = safeFormatUnits(bidBalance, 18);

        return {
            data: auctionData,
            status: true,
        };
    } catch (error) {
        console.error("Error placing bid:", error);
        return {
            status: error.message || "Failed to place bid. Please try again.",
            error: true,
        };
    }
};

/**
 *
 */
export const claimRefundHandler = async (userAddress, contractAddress) => {
    const provider = window.ethereum;
    if (!provider || !userAddress) {
        return {
            status: "💡 Connect your wallet provider to continue.",
        };
    }

    try {
        const auctionContract = initializeAuctionContract(contractAddress);

        // Call claimRefund
        const refundTransactionParameters = {
            data: auctionContract.methods.claimRefund().encodeABI(),
            from: userAddress,
            to: contractAddress,
        };

        const refundTxHash = await provider.request({
            method: "eth_sendTransaction",
            params: [refundTransactionParameters],
        });

        // Wait for transaction to be mined
        await new Promise((resolve) => {
            const checkTx = async () => {
                const receipt = await web3.eth.getTransactionReceipt(refundTxHash);
                if (receipt) {
                    resolve();
                } else {
                    setTimeout(checkTx, 1000);
                }
            };
            checkTx();
        });

        // Get updated auction state
        const auctionState = await auctionContract.methods.getAuctionState().call();
        const paused = await auctionContract.methods.paused().call();
        const pool = await auctionContract.methods.pool().call();

        let userBidAmounts = 0;
        const userAddress1 =
            localStorage.getItem("userAddress") || "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266";
        if (paused && userAddress1 !== "0x0") {
            userBidAmounts = await auctionContract.methods.userBidFees(userAddress1).call();
        }

        // Construct updated auction data
        const auctionData = {
            userBidFees: userBidAmounts,
            address: contractAddress,
            assetDelivered: auctionState._assetDelivered,
            assetDescription: auctionState._assetDescription,
            assetLocation: auctionState._assetLocation,
            assetType: auctionState._assetType.toString(),
            auctionEndTime: auctionState._auctionEndTime,
            auctionEnded: auctionState._auctionEnded,
            currentBidPrice: auctionState._currentBidPrice.toString(),
            discountFee: auctionState._discountFee,
            fomoPhaseActive: auctionState._fomoPhaseActive,
            paused: paused,
            rewardAssetPurchased: auctionState._rewardAssetPurchased,
            ownerConfirmedDelivery: auctionState._ownerConfirmedDelivery,
            rewardAssetAddress: auctionState._rewardAssetAddress.toLowerCase(),
            rewardAssetPrice: safeFormatUnits(auctionState._rewardAssetPrice, 6),
            rewardAssetQty: safeFormatUnits(auctionState._rewardAssetQty, 0),
            totalProfit: auctionState._totalProfit.toString(),
            winnerConfirmedDelivery: auctionState._winnerConfirmedDelivery,
            winningBidder: auctionState._winningBidder.toLowerCase(),
            rewardAssetPurchased: auctionState._rewardAssetPurchased,
            pool: pool,
        };

        // Calculate progress and reserve price
        const reservePrice =
            Number(auctionState._rewardAssetQty) *
            Number(formatUnits(auctionState._rewardAssetPrice, 6));
        const progress = (Number(auctionState._currentBidPrice) / reservePrice) * 100;
        auctionData.progress = progress;
        auctionData.reservePrice = reservePrice;

        // Get updated balances
        const usdtBalance = await tetherTokenContract.methods.balanceOf(userAddress).call();
        const bidBalance = await bidCoinContract.methods.balanceOf(userAddress).call();
        auctionData.usdtBalance = safeFormatUnits(usdtBalance, 6);
        auctionData.bidBalance = safeFormatUnits(bidBalance, 18);

        toast.success("Refund claimed successfully!");

        return {
            data: auctionData,
            status: true,
        };
    } catch (error) {
        console.error("Error claiming refund: " + error.message);
        throw error;
    }
};
export const winnerClaimFunction = async (userAddress, contractAddress) => {
    const provider = window.ethereum;
    if (!provider || !userAddress) {
        return {
            status: "💡 Connect your wallet provider to continue.",
        };
    }

    try {
        const auctionContract = initializeAuctionContract(contractAddress);
        const auctionState = await auctionContract.methods.getAuctionState().call();

        // Get the current bid price from auction state
        const usdtAmountInWei = parseUnits((auctionState._currentBidPrice / 100).toString(), 6);

        // Check allowance
        const currentAllowance = await tetherTokenContract.methods
            .allowance(userAddress, contractAddress)
            .call();

        if (BigInt(currentAllowance) < BigInt(usdtAmountInWei)) {
            const approveTransactionParameters = {
                data: tetherTokenContract.methods
                    .approve(contractAddress, usdtAmountInWei)
                    .encodeABI(),
                from: userAddress,
                to: tetherTokenAddress,
            };

            const approveTxHash = await provider.request({
                method: "eth_sendTransaction",
                params: [approveTransactionParameters],
            });

            await new Promise((resolve) => {
                const checkTx = async () => {
                    const receipt = await web3.eth.getTransactionReceipt(approveTxHash);
                    if (receipt) resolve();
                    else setTimeout(checkTx, 1000);
                };
                checkTx();
            });
        }

        const claimTransactionParameters = {
            data: auctionContract.methods.winnerClaim().encodeABI(),
            from: userAddress,
            to: contractAddress,
        };

        const claimTxHash = await provider.request({
            method: "eth_sendTransaction",
            params: [claimTransactionParameters],
        });

        await new Promise((resolve) => {
            const checkTx = async () => {
                const receipt = await web3.eth.getTransactionReceipt(claimTxHash);
                if (receipt) resolve();
                else setTimeout(checkTx, 1000);
            };
            checkTx();
        });

        // Get updated auction state
        const updatedAuctionState = await auctionContract.methods.getAuctionState().call();

        let userBidAmounts = 0;
        const userAddress1 = localStorage.getItem("userAddress") || "0x0";
        if (updatedAuctionState._paused && userAddress1 !== "0x0") {
            userBidAmounts = await auctionContract.methods.userBidFees(userAddress1).call();
        }

        const auctionData = {
            userBidFees: userBidAmounts,
            address: contractAddress,
            assetDelivered: updatedAuctionState._assetDelivered,
            assetType: updatedAuctionState._assetType.toString(),
            auctionEndTime: updatedAuctionState._auctionEndTime,
            auctionEnded: updatedAuctionState._auctionEnded,
            currentBidPrice: updatedAuctionState._currentBidPrice.toString(),
            discountFee: safeFormatUnits(updatedAuctionState._discountFee, 6),
            fomoPhaseActive: updatedAuctionState._fomoPhaseActive,
            paused: updatedAuctionState._paused,
            ownerConfirmedDelivery: updatedAuctionState._ownerConfirmedDelivery,
            rewardAssetAddress: updatedAuctionState._rewardAssetAddress.toLowerCase(),
            rewardAssetPrice: safeFormatUnits(updatedAuctionState._rewardAssetPrice, 6),
            rewardAssetQty: safeFormatUnits(updatedAuctionState._rewardAssetQty, 0),
            totalProfit: updatedAuctionState._totalProfit.toString(),
            winnerConfirmedDelivery: updatedAuctionState._winnerConfirmedDelivery,
            winningBidder: updatedAuctionState._winningBidder.toLowerCase(),
            rewardAssetPurchased: updatedAuctionState._rewardAssetPurchased,
            pool: updatedAuctionState._poolAddress,
            numberOfBids: updatedAuctionState._numberOfBids.toString(),
            lastPriceUpdateTimestamp: updatedAuctionState._lastPriceUpdateTimestamp,
            canEndAuction: updatedAuctionState._canEndAuction,
            refundClaimable: updatedAuctionState._refundClaimable,
            usdtPerBidCoin: updatedAuctionState._usdtPerBidCoin,
        };

        const reservePrice =
            Number(updatedAuctionState._rewardAssetQty) *
            Number(formatUnits(updatedAuctionState._rewardAssetPrice, 6));
        const progress = (Number(updatedAuctionState._currentBidPrice) / reservePrice) * 100;
        auctionData.progress = progress;
        auctionData.reservePrice = reservePrice;

        const usdtBalance = await tetherTokenContract.methods.balanceOf(userAddress).call();
        const bidBalance = await bidCoinContract.methods.balanceOf(userAddress).call();
        auctionData.usdtBalance = safeFormatUnits(usdtBalance, 6);
        auctionData.bidBalance = safeFormatUnits(bidBalance, 18);

        return {
            data: auctionData,
            status: true,
        };
    } catch (error) {
        console.error("Error claiming winner's reward: " + error.message);
        throw error;
    }
};
/**
 *
 */
const safeFormatUnits = (value, decimals) => {
    try {
        return Number(formatUnits(value || "0", decimals)).toString();
    } catch (error) {
        console.error("Error formatting units:", error);

        return "0";
    }
};
export const claimRewardHandler = async (userAddress, contractAddress) => {
    if (!window.ethereum || !userAddress) {
        return {
            status: "💡 Connect your wallet provider to continue.",
        };
    }

    try {
        const auctionContract = initializeAuctionContract(contractAddress);
        const claimRewardTxHash = await auctionContract.methods
            .endAuction()
            .send({ from: userAddress });

        toast.success("You've earned bonus BidCoins!");
        return {
            status: true,
            txHash: claimRewardTxHash.transactionHash,
        };
    } catch (error) {
        console.error("Error claiming reward: ", error);
        return {
            status: "😥 " + error.message,
        };
    }
};

/**
 *
 */
export const burnBidHandler = async (userAddress, contractAddress) => {
    if (!window.ethereum || !userAddress) {
        return {
            status: "💡 Connect your wallet provider to continue.",
        };
    }

    try {
        const auctionContract = initializeAuctionContract(contractAddress);
        const auctionState = await auctionContract.methods.getAuctionState().call();
        const discountFee = await auctionContract.methods.discountFee().call();

        const bidAmount = formatUnits(discountFee, 6) / 50;
        const usdtAmountInWei = parseUnits(bidAmount.toString(), 18);

        // Check allowance
        const currentAllowance = await bidCoinContract.methods
            .allowance(userAddress, contractAddress)
            .call();

        if (BigInt(currentAllowance) < BigInt(usdtAmountInWei)) {
            const approveTransactionParameters = {
                data: bidCoinContract.methods.approve(contractAddress, usdtAmountInWei).encodeABI(),
                from: userAddress,
                to: bidCoinAddress,
            };

            const approveTxHash = await window.ethereum.request({
                method: "eth_sendTransaction",
                params: [approveTransactionParameters],
            });

            await new Promise((resolve) => {
                const checkTx = async () => {
                    const receipt = await web3.eth.getTransactionReceipt(approveTxHash);
                    if (receipt) resolve();
                    else setTimeout(checkTx, 1000);
                };
                checkTx();
            });
        }

        const bidTransactionParameters = {
            data: auctionContract.methods.placeBidWithBidCoin().encodeABI(),
            from: userAddress,
            to: contractAddress,
        };

        const bidTxHash = await window.ethereum.request({
            method: "eth_sendTransaction",
            params: [bidTransactionParameters],
        });

        await new Promise((resolve) => {
            const checkTx = async () => {
                const receipt = await web3.eth.getTransactionReceipt(bidTxHash);
                if (receipt) resolve();
                else setTimeout(checkTx, 1000);
            };
            checkTx();
        });

        // Get updated auction state
        const updatedAuctionState = await auctionContract.methods.getAuctionState().call();

        let userBidAmounts = 0;
        const userAddress1 = localStorage.getItem("userAddress") || "0x0";
        if (updatedAuctionState._paused && userAddress1 !== "0x0") {
            userBidAmounts = await auctionContract.methods.userBidFees(userAddress1).call();
        }

        const auctionData = {
            userBidFees: userBidAmounts,
            address: contractAddress,
            assetDelivered: updatedAuctionState._assetDelivered,
            assetType: updatedAuctionState._assetType.toString(),
            auctionEndTime: updatedAuctionState._auctionEndTime,
            auctionEnded: updatedAuctionState._auctionEnded,
            currentBidPrice: updatedAuctionState._currentBidPrice.toString(),
            discountFee: safeFormatUnits(updatedAuctionState._discountFee, 6),
            fomoPhaseActive: updatedAuctionState._fomoPhaseActive,
            paused: updatedAuctionState._paused,
            ownerConfirmedDelivery: updatedAuctionState._ownerConfirmedDelivery,
            rewardAssetAddress: updatedAuctionState._rewardAssetAddress.toLowerCase(),
            rewardAssetPrice: safeFormatUnits(updatedAuctionState._rewardAssetPrice, 6),
            rewardAssetQty: safeFormatUnits(updatedAuctionState._rewardAssetQty, 0),
            totalProfit: updatedAuctionState._totalProfit.toString(),
            winnerConfirmedDelivery: updatedAuctionState._winnerConfirmedDelivery,
            winningBidder: updatedAuctionState._winningBidder.toLowerCase(),
            rewardAssetPurchased: updatedAuctionState._rewardAssetPurchased,
            pool: updatedAuctionState._poolAddress,
            numberOfBids: updatedAuctionState._numberOfBids.toString(),
            lastPriceUpdateTimestamp: updatedAuctionState._lastPriceUpdateTimestamp,
            canEndAuction: updatedAuctionState._canEndAuction,
            refundClaimable: updatedAuctionState._refundClaimable,
            usdtPerBidCoin: updatedAuctionState._usdtPerBidCoin,
        };

        const reservePrice =
            Number(updatedAuctionState._rewardAssetQty) *
            Number(formatUnits(updatedAuctionState._rewardAssetPrice, 6));
        const progress = (Number(updatedAuctionState._currentBidPrice) / reservePrice) * 100;
        auctionData.progress = progress;
        auctionData.reservePrice = reservePrice;

        const usdtBalance = await tetherTokenContract.methods.balanceOf(userAddress).call();
        const bidBalance = await bidCoinContract.methods.balanceOf(userAddress).call();
        auctionData.usdtBalance = safeFormatUnits(usdtBalance, 6);
        auctionData.bidBalance = safeFormatUnits(bidBalance, 18);

        return {
            data: auctionData,
            status: true,
        };
    } catch (error) {
        console.error("Error burning bid: " + error);
        return {
            status: "😥 " + error.message,
        };
    }
};
